import React, {MouseEventHandler, FC} from 'react'
import '../css/components/FAButton.scss'
import { PUBLIC_FOLDER } from '../constants/urls'

interface FabProps {
  action: MouseEventHandler<HTMLButtonElement>
}

const FAButton: FC<FabProps> = ({action}) => {
  return (
    <button className="update" onClick={action}>
      <img src={PUBLIC_FOLDER + '/icons/md_refresh_24px.svg'} alt="Refresh" />
    </button>
  )
}

export default FAButton
